import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { concatMap, mergeMap } from 'rxjs/operators';
import * as recordLabels from '@webapp/sdk/record-labels';
import { Actions } from '../../actions';
import {
  CreateRecordLabelInvite,
  CreateRecordLabelInviteError,
  CreateRecordLabelInviteSuccess,
} from '../action-creators';
import { CREATE_RECORD_LABEL_INVITE } from '../actions';
import { GetRecordLabelInvites } from '@webapp/store/invites/action-creators';

export const inviteRecordLabelEpic = (action$: Observable<Actions>) =>
  action$.pipe(
    ofType<Actions, CreateRecordLabelInvite>(CREATE_RECORD_LABEL_INVITE),
    mergeMap(async (action) => {
      try {
        await recordLabels.inviteRecordLabel(
          action.recordLabelId,
          action.invite
        );

        return [
          new CreateRecordLabelInviteSuccess(),
          new GetRecordLabelInvites(action.recordLabelId, 'record-label'),
        ];
      } catch (err) {
        return [new CreateRecordLabelInviteError(err.message)];
      }
    }),
    concatMap((actions) => actions)
  );
